import React from 'react'

import { Question } from './Question/Question'
import { ResultsStatusBar } from './ResultsStatusBar/ResultsStatusBar'
import { Review } from './Review/Review'

import { useAppSelector } from 'common/hooks'
import { Task } from 'common/types/entities'
import { selectIsFinished } from 'features/exam'

type ParamsType = {
  tasks: Task[]
  testId: string
}

export const ExamInterface = ({ tasks, testId }: ParamsType) => {
  const isExamFinished = useAppSelector(selectIsFinished)

  if (isExamFinished) {
    return <Review testId={testId} tasks={tasks} />
  }

  return (
    <div>
      <ResultsStatusBar />
      <Question tasks={tasks} />
    </div>
  )
}
